import React from "react";
import { NavLink } from "react-router-dom";
import cx from "classnames";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import styles from './Text.module.scss';

function Text() {

  return (
      <div className={styles.container}>
        <Container className={styles.textContainer}>
          <Row>
            <Col xxl={6}>
              <h2 className={styles.title}>
                Публичная оферта для пользователей сайта vedmarket.ru
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xl={10} xxl={8}>
              <span className={styles.dateInfo}>
                Актуальная редакция: 17&nbsp;июня 2025&nbsp;г.
              </span>
              <div className={styles.text}>
                <h3 className={styles.subtitle}>1. Общие положения</h3>
                <p className={styles.paragraph}>
                  Настоящим, заполняя любую форму на&nbsp;сайте vedmarket.ru (далее&nbsp;&mdash; &laquo;Сайт&raquo;) и&nbsp;нажимая кнопку &quot;Отправить&quot;/&quot;Оставить заявку&quot; либо продолжая использование Сайта, вы&nbsp;свободно, своей волей и&nbsp;в&nbsp;своих интересах подтверждаете, что ознакомились с&nbsp;настоящим Согласием и&nbsp;разрешаете ООО &laquo;ВедМаркет&raquo; (ИНН 7712345678, ОГРН 1207700000000, e-mail: <a
                    className={styles.link}
                    href="mailto:privacy@vedmarket.ru">privacy@vedmarket.ru</a>, далее&nbsp;&mdash; &laquo;Оператор&raquo;) обрабатывать ваши персональные данные на&nbsp;условиях, изложенных ниже
                </p>
                <h3 className={styles.subtitle}>2. Цели обработки</h3>
                <ul className={cx(styles.paragraphList, styles.paragraph)}>
                  <li>
                    Идентификация пользователя на&nbsp;Сайте и&nbsp;в&nbsp;мобильных приложениях.
                  </li>
                  <li>
                    Оформление и&nbsp;сопровождение заказов.
                  </li>
                  <li>
                    Информирование об&nbsp;акциях, новостях и&nbsp;специальных предложениях (e-mail, SMS, push-уведомления).
                  </li>
                  <li>
                    Улучшение качества сервисов, проведение статистических и&nbsp;маркетинговых исследований.
                  </li>
                  <li>
                    Выполнение требований законодательства&nbsp;РФ (бухучёт, налоговая отчётность и&nbsp;др.).
                  </li>
                </ul>
                <h3 className={styles.subtitle}>3. Категории персональных данных</h3>
                <ul className={cx(styles.paragraphList, styles.paragraph)}>
                  <li>
                    Идентификационные. Фамилия, имя, отчество; дата рождения (при необходимости).
                  </li>
                  <li>
                    Контактные. Номер телефона, e-mail, почтовый адрес.
                  </li>
                  <li>
                    Данные учётной записи. Логин, хэш пароля, история авторизаций, IP-адрес, cookie-файлы.
                  </li>
                  <li>
                    Платежные. Реквизиты платежа, сумма и&nbsp;дата операций (обрабатываются через платёжного агрегатора).
                  </li>
                  <li>
                    ТранзакционныеСписок товаров/услуг, история заказов, комментарии к&nbsp;заказам.
                  </li>
                </ul>
                <h3 className={styles.subtitle}>4. Правовые основания</h3>
                <p className={styles.paragraph}>
                  Обработка осуществляется в&nbsp;соответствии&nbsp;с:
                  <ul className={styles.paragraphList}>
                    <li>
                      Федеральным законом&nbsp;РФ от&nbsp;27.07.2006 &#8470;&nbsp;152-ФЗ &laquo;О&nbsp;персональных данных&raquo;;
                    </li>
                    <li>
                      Федеральным законом&nbsp;РФ от&nbsp;07.02.1992 &#8470;&nbsp;2300-1 &laquo;О&nbsp;защите прав потребителей&raquo;;
                    </li>
                    <li>
                      Настоящим Согласием (оферта).
                    </li>
                  </ul>
                </p>
                <h3 className={styles.subtitle}>5. Способы обработки и срок хранения</h3>
                <ul className={cx(styles.paragraph, styles.paragraphList)}>
                  <li>
                    Смешанная (автоматизированная и&nbsp;неавтоматизированная) обработка с&nbsp;использованием баз данных на&nbsp;территории РФ.
                  </li>
                  <li>
                    Срок хранения&nbsp;&mdash; до&nbsp;достижения целей обработки или до&nbsp;момента отзыва Согласия, если иное не&nbsp;требуется законодательством (данные о&nbsp;заказах&nbsp;&mdash; 5&nbsp;лет, бухгалтерские документы&nbsp;&mdash; 5&nbsp;лет и&nbsp;т.д.)
                  </li>
                </ul>
                <h3 className={styles.subtitle}>6. Передача третьим лицам</h3>
                <p className={styles.paragraph}>
                  Персональные данные могут быть переданы исключительно для целей, указанных в&nbsp;разделе&nbsp;2, следующим категориям получателей:
                  <ul className={styles.paragraphList}>
                    <li>
                      Курьерские и&nbsp;почтовые службы (доставка).
                    </li>
                    <li>
                      Платёжные агрегаторы (приём онлайн-платежей).
                    </li>
                    <li>
                      Внешние сервисы технической поддержки, CRM, облачные хостинги, расположенные на&nbsp;территории РФ.
                    </li>
                    <li>
                      Уполномоченные госорганы&nbsp;&mdash; по&nbsp;их&nbsp;запросу на&nbsp;основании закона.
                    </li>
                  </ul>
                  Передача данных в&nbsp;иные страны или третьим лицам без вашей отдельной воли не&nbsp;осуществляется.
                </p>
                <h3 className={styles.subtitle}>7. Права субъекта персональных данных</h3>
                <p className={styles.paragraph}>
                  Вы&nbsp;вправе:
                  <ul className={styles.paragraphList}>
                    <li>
                      Получать информацию о&nbsp;факте, целях, источнике, способах обработки ваших данных;
                    </li>
                    <li>
                      Требовать уточнения, блокировки или уничтожения недостоверных либо незаконно обработанных данных;
                    </li>
                    <li>
                      Отозвать настоящее Согласие в&nbsp;любой момент, направив запрос на&nbsp;e-mail <a className={styles.link} href="mailto:privacy@vedmarket.ru">privacy@vedmarket.ru</a>;
                    </li>
                    <li>
                      Обжаловать действия/бездействие Оператора в&nbsp;Роскомнадзор или в&nbsp;судебном порядке.
                    </li>
                  </ul>
                </p>
                <h3 className={styles.subtitle}>8. Отзыв Согласия</h3>
                <p className={styles.paragraph}>
                  Отзыв не&nbsp;влияет на&nbsp;законность обработки, осуществлённой до&nbsp;момента получения Оператором письменного уведомления. После получения отзыва ваш аккаунт может быть ограничен или удалён в&nbsp;зависимости от&nbsp;минимально необходимого состава данных для выполнения обязательств перед вами и&nbsp;норм законодательства.
                </p>
                <h3 className={styles.subtitle}>9. Контактная информация Оператора</h3>
                <p className={styles.paragraph}>
                  ООО «ВедМаркет» <br/>
                  109029, г. Москва, ул. Примерная, д. 1, стр. 2<br/>
                  Тел.: <a className={styles.link} href="tel:+74950000000">+7 495 000-00-00</a><br/>
                  E-mail: <a className={styles.link} href="mailto:privacy@vedmarket.ru">privacy@vedmarket.ru</a>
                </p>
                <p className={styles.textBottom}>
                  Продолжая работу на&nbsp;сайте vedmarket.ru, вы&nbsp;подтверждаете своё согласие с&nbsp;указанными условиями обработки персональных данных.
                </p>
                <NavLink to="/" className={styles.textLink}>
                  Перейти на главную страницу
                </NavLink>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
  );
}

export default Text;
